module.exports = __webpack_public_path__ + "img/I-07366_96.c9faa3d1.jpg";